import { component } from 'flightjs';

function SmsCheckUI() {
    this.defaultAttrs({
        smsSid: '[data-sms-sid]',
        errorMessage: '[data-sms-error]'
    });

    this._getSmsCheckPayload = function() {
        let smsSid = this.select('smsSid').data('smsSid');
        return { sid: smsSid };
    };

    this._triggerSmsCheck = function() {
        let payload = this._getSmsCheckPayload();

        if (payload.sid) {
            this.trigger(document, 'ui:sms-check:query', payload);
        }
    };

    this._showError = function(evt, payload) {
        if (!payload.successful) {
            this.select('errorMessage').removeClass('hidden');
        }
    };

    this.after('initialize', function() {
        this._triggerSmsCheck();
        this.on(document, 'data:sms-check:query', this._showError);
    });
}

export default component(SmsCheckUI);
